import { Box, Grid, List, Stack, Text, ThemeIcon, Title } from "@repo/ui/core";
import { IconArrowRight, IconCheck, IconX } from "@repo/ui/icons";
import { motion } from "framer-motion";
import classes from "@styles/onsite.module.css";

type Props = {
  title: string;
  leftLabel: string;
  leftItems: string[];
  rightLabel: string;
  rightItems: string[];
};

export function ComparisonSlide({
  title,
  leftLabel,
  leftItems,
  rightLabel,
  rightItems,
}: Props) {
  return (
    <Box w="100%" maw={1400} px="xl">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Stack gap="xl">
          <Title
            order={1}
            size="clamp(36px, 5vw, 64px)"
            fw={800}
            style={{ letterSpacing: "-0.02em" }}
          >
            {title}
          </Title>

          <Grid gutter="xl">
            <Grid.Col span={{ base: 12, md: 5 }}>
              <motion.div
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.2 }}
              >
                <Box
                  p="xl"
                  className={classes.panelNegative}
                >
                  <Text fw={700} size="xl" mb="lg" c="red.4">
                    {leftLabel}
                  </Text>
                  <List spacing="md" icon={<ThemeIcon size={28} radius="xl" variant="light" color="red"><IconX size={16} /></ThemeIcon>}>
                    {leftItems.map((item) => (
                      <List.Item key={item}>
                        <Text size="lg" c="dimmed">
                          {item}
                        </Text>
                      </List.Item>
                    ))}
                  </List>
                </Box>
              </motion.div>
            </Grid.Col>

            <Grid.Col
              span={{ base: 12, md: 2 }}
              style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
            >
              <motion.div
                initial={{ opacity: 0, scale: 0.5 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: 0.4 }}
              >
                <IconArrowRight
                  size={44}
                  style={{ color: "var(--customer-accent-light)" }}
                />
              </motion.div>
            </Grid.Col>

            <Grid.Col span={{ base: 12, md: 5 }}>
              <motion.div
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.3 }}
              >
                <Box
                  p="xl"
                  className={classes.panelPositive}
                >
                  <Text fw={700} size="xl" mb="lg" style={{ color: "var(--customer-accent-light)" }}>
                    {rightLabel}
                  </Text>
                  <List
                    spacing="md"
                    icon={
                      <ThemeIcon size={28} radius="xl" variant="light" color="green">
                        <IconCheck size={16} />
                      </ThemeIcon>
                    }
                  >
                    {rightItems.map((item) => (
                      <List.Item key={item}>
                        <Text size="lg">{item}</Text>
                      </List.Item>
                    ))}
                  </List>
                </Box>
              </motion.div>
            </Grid.Col>
          </Grid>
        </Stack>
      </motion.div>
    </Box>
  );
}
